import React from 'react';
import { useWishList } from '@/context/wishlist/WishListContext';
import WishListButton from './Button';
const Wishlist = () => {
  const { wishList } = useWishList();
  return <WishListButton count={wishList?.length} />;
};

export default Wishlist;
